import { exportToExcel } from 'lib/designSystem/DataExporter/utils/exportToExcel';

import { Payment } from '../../types';

export const handleExportConsorcioXLSX = async (
  payments: Payment[],
  id: string,
  message?: string,
) => {
  const messsage = message || `Operación ${id}`;
  const headers = [
    { key: 'bankAccountDestinationHolderIdentifier', label: 'Rut Destino' },
    { key: 'bankAccountDestinationHolderName', label: 'Nombre' },
    {
      key: 'bankAccountDestinationAccountType',
      label: 'Tipo Cuenta',
    },
    { key: 'bankAccountDestinationBankCode', label: 'Código Banco' },
    {
      key: 'bankAccountDestinationNumber',
      label: 'Número de Cuenta destino',
    },
    {
      key: 'amount',
      label: 'Monto',
    },
    {
      key: 'bankAccountDestinationHolderEmail',
      label: 'Email',
    },
    { key: 'customizedTransferNote', label: 'Observación' },
    {
      key: 'bankAccountOriginNumber',
      label: 'Identificador Origen',
    },
  ];

  const data = payments.map((p) => {
    return {
      ...p,
      customizedTransferNote: messsage,
    };
  });

  await exportToExcel(
    data,
    headers,
    `Consorcio_${id}_${payments[0].bankAccountDestinationHolderName}.xlsx`,
  );
};
